import { lazyImport } from "../../utility/lazyImport";

const { CreateRepresentation } = lazyImport(
  () => import("../../features/representation/routes"),
  "CreateRepresentation"
);

const { RepresentationCreated } = lazyImport(
  () => import("../../features/representation"),
  "RepresentationCreated"
);

const { Representations } = lazyImport(
  () => import("../../features/representation"),
  "Representations"
);
const { Representation } = lazyImport(
  () => import("../../features/representation"),
  "Representation"
);

const { PublicRepresentations } = lazyImport(
    () => import("../../features/representation"),
    "PublicRepresentations"
);
const { PublicRepresentation } = lazyImport(
    () => import("../../features/representation"),
    "PublicRepresentation"
);

const RepresentationRoutes = [
  {
    path: "/create-representation",
    element: <CreateRepresentation />,
    meta: {
      publicRoute: true,
      action: "create",
      resource: "representation",
    },
  },
  {
    path: "/dashboard/representations/create",
    element: <CreateRepresentation />,
    meta: {
      publicRoute: true,
      action: "create",
      resource: "representation",
    },
  },
  {
    path: "/create-representation/success",
    element: <RepresentationCreated />,
    meta: {
      publicRoute: true,
      action: "create",
      resource: "representation",
    },
  },
  {
    path: "/dashboard/representations",
    element: <Representations />,
    meta: {
      publicRoute: true,
      action: "create",
      resource: "representation",
    },
  },
  {
    path: "/dashboard/representations/:id",
    element: <Representation />,
    meta: {
      publicRoute: true,
      action: "create",
      resource: "representation",
    },
  },
  {
    path: "/representations",
    element: <PublicRepresentations />,
    meta: {
      publicRoute: true,
      menuHidden: true,
      layout: "blank",
    },
  },
  {
    path: "/representations/:id",
    element: <PublicRepresentation />,
    meta: {
      publicRoute: true,
      menuHidden: true,
      layout: "blank",
    },
  },
];

export default RepresentationRoutes;
